import classNames from 'classnames';
import React from 'react';
import {observer} from 'mobx-react';

import styles from './sticky-header.module.scss';

import {EnrollmentCount} from '@/features/course-landing-page/components/enrollment-count/enrollment-count.react-component';
import {RatingDisplay} from '@/features/course-landing-page/components/rating-display/rating-display.react-component';
import {CourseRating} from '@udemy-v2/browse-course';
import {CourseRibbonWrapper} from '@udemy-v2/react-browse-course';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import {useSmartBarRef} from '@udemy-v2/react-smart-bar';

interface StickyHeaderProps {
    rating: CourseRating;
    numEnrollments?: number;
    title: string;
}

export const StickyHeader = observer(({rating, numEnrollments, title}: StickyHeaderProps) => {
    const course = useClpCourse();
    const {smartBarHeight, isSticky, isHidden} = useSmartBarRef();

    const shouldApplyOffset = isSticky && !isHidden;

    return (
        <div className={'ud-color-scheme-dark'}>
            <div
                className={styles['sticky-header-container']}
                style={shouldApplyOffset ? {top: `${smartBarHeight}px`} : {}}
            >
                <div className={classNames('ud-text-bold', 'ud-text-md', styles['title'])}>
                    {title}
                </div>
                <div className={styles['info']}>
                    <CourseRibbonWrapper course={course} numberOfBadgesToShow={2} />
                    <span>
                        {rating?.average && (
                            <RatingDisplay average={rating.average} count={rating.count} numeric />
                        )}
                    </span>
                    <span>{numEnrollments && <EnrollmentCount count={numEnrollments} />}</span>
                </div>
            </div>
        </div>
    );
});
